import { IValidacaoDistribuicaoEpiUseCase } from "../../../presentation/useCases/read/validacao_distribuicao_epi_use_case";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

export class ValidacaoDistribuicaoEpiUseCase implements IValidacaoDistribuicaoEpiUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) {}

  async validacaoDistribuicaoEpi(
    idGestaoDistribuicaoEpi: number,
    imagem: string,
  ): Promise<void> {
    const imagemArr = imagem.split(",");
    // if (imagem.length < 2) {
      await this.repository.validacaoDistribuicaoEpi(
        idGestaoDistribuicaoEpi,
        imagem,
      );
    // } else {
    //   console.log("caiu 2");

    //   await this.repository.validacaoDistribuicaoEpi(
    //     idGestaoDistribuicaoEpi,
    //     imagemArr,
    //   );
    // }
  }
}
